.sidebar {
  overflow: auto;
  margin-top: 8px;
  background-color: var(--tuna-palette-layers);
  border-right: solid 1px var(--tuna-palette-divider);
  color: var(--tuna-palette-text-secondary);
  transition: width var(--tuna-transitions-duration-standard, 300ms) var(--tuna-transitions-easing-easeInOut, ease);
  z-index: 1;
  width: 192px;
  position: relative;
  flex-shrink: 0;
}

.sidebar--no-transition {
  transition: none;
}

.sidebar--collapsed {
  width: 48px;
  overflow: hidden;
}

.userRow {
  margin-left: 16px;
  display: flex;
  position: sticky;
  top: 0;
  background: var(--tuna-palette-layers);
  z-index: 1;
  padding: 4px 0;
  flex-shrink: 0;
}

/* The nav scrolls on its own, between the user row and the collapse button. When the whole sidebar
   scrolled, rows slid under those sticky controls and were left with a sliver of hit area (2.5.8). */
.nav {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.menuItem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
  border: none;
  background: none;
  color: inherit;
  width: 100%;
  text-align: left;
  font-size: var(--tuna-typography-fontSize-md);
  white-space: nowrap;
}

.sidebar--collapsed .menuItem {
  justify-content: center;
  padding: 8px 12px;
}

.menuItem--active {
  background-color: var(--tuna-palette-action-selected);
}

.menuItem--muted {
  /* Section labels and empty states are text people read: secondary colour, not reduced opacity (was 3:1) */
  color: var(--tuna-content-secondary);
  cursor: default;
}

.spacer {
  flex: 1;
}

.collapseButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px;
  border: none;
  background: var(--tuna-palette-layers);
  color: var(--tuna-palette-text-secondary);
  cursor: pointer;
  border-top: 1px solid var(--tuna-palette-divider);
  transition: background-color var(--tuna-transitions-duration-shortest, 150ms);
  position: sticky;
  bottom: 0;
  flex-shrink: 0;
}

.collapseButton:hover {
  background-color: var(--tuna-palette-action-hover);
}

.resizeHandle {
  position: absolute;
  top: 0;
  right: -3px;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  z-index: 2;
}

.resizeHandle:hover,
.resizeHandle:active {
  background: var(--tuna-palette-primary-main);
  opacity: 0.5;
}
